var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-image",staticStyle:{"background-image":"url('https://images.rawpixel.com/image_1000/cHJpdmF0ZS9sci9pbWFnZXMvd2Vic2l0ZS8yMDIzLTA3L3Jhd3BpeGVsX29mZmljZV82X3Bob3RvZ3JhcGh5X29mX2xpZ2h0X2FuZF9jbGVhbl9neW1fZXhlcmNpc2VfZV81ZDMxM2VhYS05NTY2LTQxNTgtOTMyMi1lYzZkNWU2YWNkNDguanBn.jpg')"}},[_c('new-workout-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }